export default __webpack_public_path__ + "static/hp-pharmaco-tsat-chart-LG-d76141ced018247b24931843135a0cf2.png";